const MonthSelect = ({
  selectedMonth,
  selectedMonthName,
  months,
  onChange,
}) => (
  <div className="col-sm-3">
    <select
      className="form-select"
      name="selectedMonth"
      onChange={onChange}
      value={selectedMonth || ""}
    >
      {/* placeholder option */}
      <option value="" disabled={!!(selectedMonth || selectedMonthName)}>
        Select Month
      </option>

      <option value="AllMonths">All Months</option>

      {months().map((month, idx) => (
        <option key={idx} value={JSON.stringify(month.createdAt)}>
          {month.name}
        </option>
      ))}
    </select>
  </div>
);

export default MonthSelect;
